<template>
  <div class="ui center aligned container">
    <h1 class="ui center aligned header">Welk scherm wil je opzetten?</h1>
    <div class="ui two item stackable orange inverted menu">
      <a class="item" @click.prevent="enterPin = !enterPin"
        ><i class="lock icon"></i> Quizmasterscherm</a
      >
      <a class="item" @click.prevent="openPlayersScreen"
        ><i class="users icon"></i> Deelnemersscherm</a
      >
    </div>
    <div class="ui hidden divider"></div>
    <transition name="fade" :appear="true">
      <div class="ui icon massive input" v-if="enterPin">
        <input
          type="text"
          placeholder="PIN"
          maxlength="4"
          size="4"
          v-model="pinCode"
        />
        <i class="unlock alternate icon"></i>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'host-or-player-picker',
  data() {
    return {
      pinCode: null,
      enterPin: false
    };
  },
  watch: {
    pinCode: function(val) {
      if (val === this.$store.state.pinCode) {
        // add PIN to the url to avoid having to re-enter it after a browser refresh
        this.$router.replace({ name: 'playGame', params: { pinCode: val } });
        this.$store.dispatch('openHostScreen', val);
      }
    }
  },
  methods: {
    openPlayersScreen() {
      this.$store.commit('ACTIVATE_PLAYERS_SCREEN');
    }
  }
};
</script>

<style scoped>
.ui.menu .item {
  font-size: 2.5rem;
  text-shadow: none;
}
@media only screen and (max-width: 991px) {
  .ui.menu .item {
    font-size: 1.6rem;
    text-shadow: none;
  }
}
</style>
